/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Group_LabelInputs */

const en_editor_group_label = /** @type {(inputs: Editor_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const de_editor_group_label = /** @type {(inputs: Editor_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Editor_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_group_label = /** @type {((inputs?: Editor_Group_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Group_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_group_label(inputs)
	return en_editor_group_label(inputs)
});